module.exports = __webpack_public_path__ + "static/img/bg6.24518e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg6.jpg
// module id = +sXr
// module chunks = 1